import { render, staticRenderFns } from "./GlobalTab.vue?vue&type=template&id=690b6df9&scoped=true"
import script from "./GlobalTab.vue?vue&type=script&lang=js"
export * from "./GlobalTab.vue?vue&type=script&lang=js"
import style0 from "./GlobalTab.vue?vue&type=style&index=0&id=690b6df9&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690b6df9",
  null
  
)

export default component.exports